var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.28241 22.5C9.83469 22.5 10.2824 22.0523 10.2824 21.5C10.2824 20.9477 9.83469 20.5 9.28241 20.5C8.73012 20.5 8.28241 20.9477 8.28241 21.5C8.28241 22.0523 8.73012 22.5 9.28241 22.5Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2824 22.5C20.8347 22.5 21.2824 22.0523 21.2824 21.5C21.2824 20.9477 20.8347 20.5 20.2824 20.5C19.7301 20.5 19.2824 20.9477 19.2824 21.5C19.2824 22.0523 19.7301 22.5 20.2824 22.5Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.28241 1.5H5.28241L7.96241 14.89C8.05385 15.3504 8.30432 15.764 8.66996 16.0583C9.03559 16.3526 9.49311 16.509 9.96241 16.5H19.6824C20.1517 16.509 20.6092 16.3526 20.9749 16.0583C21.3405 15.764 21.591 15.3504 21.6824 14.89L23.2824 6.5H6.28241",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.28241 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCart);
export default __webpack_public_path__ + "static/media/btn-cart.7d75b4b2542020e5905af128b437f11a.svg";
export { ForwardRef as ReactComponent };